import { combineReducers } from 'redux';
import { all } from 'redux-saga/effects';
import invStocks, { invStocksSaga } from './invStocks';
import invHistory, { invHistorySaga } from './invHistory';
import invTranInfo, { invTranInfoSaga } from './invTranInfo';

const inventoryModule = combineReducers({
    invStocks,
    invHistory,
    invTranInfo,
});

export function* inventoryModuleSaga() {
    yield all([
        invStocksSaga(),
        invHistorySaga(),
        invTranInfoSaga(),
    ]);
}

export default inventoryModule;